// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"65fd5f3e","453":"36a400e3","732":"27c12a87"}[chunkId] + ".chunk.js";
};